import React from 'react'
import { Context } from './provider'

export const withContext = Component => {
  return props => <Context.Consumer>{data => <Component {...props} context={{ ...data }} />}</Context.Consumer>
}
